import "./InsightCard.css";

// FIXED 2026-08-05: was placeholder-only (BLOCKED on DB access). Now renders
// real computed insight text from keyInsights.js - see App.js for where
// computeRangeInsights()/computeDistributionInsights() are called. This
// component's job stays the same either way: render whatever `points`
// strings it's given, one per numbered row.
//
// Each point string may contain **double-asterisk** spans - matches the
// prototype dashboard's dark-blue-highlighted dynamic numbers/territory
// names. Split on ** pairs and render the odd-indexed segments as
// highlighted <span>s, everything else as plain text.
function renderPoint(text) {
  const segments = text.split("**");
  return segments.map((seg, i) =>
    i % 2 === 1 ? (
      <span className="ic-highlight" key={i}>
        {seg}
      </span>
    ) : (
      seg
    )
  );
}

export default function InsightCard({ eyebrow, title, points }) {
  return (
    <div className="ic-card">
      <div className="ic-head">
        <span className="ic-eyebrow">{eyebrow}</span>
        <h3 className="ic-title">{title}</h3>
      </div>
      <div className="ic-body">
        {points.map((point, i) => (
          <div className="ic-point" key={i}>
            <span className="ic-num">{i + 1}.</span>
            <p className="ic-point-text">{renderPoint(point)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
